import { Controller } from '@hotwired/stimulus'

/**
 * Maps Settings Controller
 * Handles UI interactions for the Maps configuration tab in the website editor.
 */
export default class extends Controller {
  static targets = ['mapPreview', 'advancedToggle', 'advancedSection', 'advancedIcon']

  static values = {
    websiteId: String,
    currentPreset: String
  }

  connect() {
    // Initialize advanced section as collapsed
    this.advancedExpanded = false
  }

  /**
   * Toggle the advanced custom styles section
   */
  toggleAdvanced(event) {
    event.preventDefault()
    this.advancedExpanded = !this.advancedExpanded

    if (this.hasAdvancedSectionTarget) {
      this.advancedSectionTarget.classList.toggle('hidden', !this.advancedExpanded)
    }

    if (this.hasAdvancedIconTarget) {
      this.advancedIconTarget.style.transform = this.advancedExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
    }
  }

  /**
   * Show current JSON in a modal or alert
   */
  showCurrentJson(event) {
    event.preventDefault()
    const textarea = this.element.querySelector('textarea[name="map_style_json"]')
    if (textarea && textarea.value) {
      // Copy to clipboard
      navigator.clipboard.writeText(textarea.value).then(() => {
        this.showNotification('Current styles copied to clipboard')
      }).catch(() => {
        // Fallback: select the text
        textarea.select()
        this.showNotification('Select all to copy the styles')
      })
    }
  }

  /**
   * Show a temporary notification
   */
  showNotification(message) {
    // Create a simple toast notification
    const toast = document.createElement('div')
    toast.className = 'fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in'
    toast.textContent = message

    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add('animate-fade-out')
      setTimeout(() => toast.remove(), 300)
    }, 2000)
  }
}
